module.exports = __webpack_public_path__ + "static/hyperv_49.34888546.png";